module.exports = __webpack_public_path__ + "a778d462571e545f16122f201343d460.png";